import React from 'react';
import { Section } from './Section';
import { inactionRows } from '../data/tables';
export function CostOfInaction() {
  return <Section background="paper" labelledBy="inaction-heading" data-id="element-69" data-mp="2pz9ci44kgnbr">
      <h2 id="inaction-heading" className="text-center font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[40px]" data-id="element-70" data-mp="2uxav6ny2ykmp">
        What does freezing actually cost you?
      </h2>

      <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-2xl border border-sage/15 bg-white shadow-card" data-id="element-71" data-mp="34wta2pz4vg7w">
        <table className="w-full border-collapse text-left" data-id="element-72" data-mp="38w26k2lk5s75">
          <thead data-id="element-73" data-mp="3dnto5nmqknl5">
            <tr data-id="element-74" data-mp="3dpd3nc0kiulv">
              <th scope="col" className="w-1/2 border-b border-sage/15 px-5 py-4 font-sans text-[12px] font-semibold uppercase tracking-[0.12em] text-ink-muted sm:px-7" data-id="element-75" data-mp="3dovc2soup4ka">
                Without a protocol
              </th>
              <th scope="col" className="w-1/2 border-b border-l border-sage/15 px-5 py-4 font-sans text-[12px] font-semibold uppercase tracking-[0.12em] text-flag-red sm:px-7" data-id="element-76" data-mp="3skt4bzvnlor8">
                The real cost
              </th>
            </tr>
          </thead>
          <tbody data-id="element-77" data-mp="34jbms59ydrbp">
            {inactionRows.map(([cause, cost]) => <tr key={cause} className="border-b border-sage/10 last:border-0" data-id="element-78" data-mp="30gyi7k6xzzgi">
                <td className="px-5 py-4 align-top font-sans text-[15px] leading-snug text-ink-soft sm:px-7" data-id="element-79" data-mp="30j1e2kus0mt5">
                  {cause}
                </td>
                <td className="border-l border-sage/15 px-5 py-4 align-top font-sans text-[15px] font-medium leading-snug text-ink sm:px-7" data-id="element-80" data-mp="3s95wwf2w11s9">
                  {cost}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <p className="mx-auto mt-12 max-w-2xl text-center font-serif text-2xl font-medium italic leading-snug text-brass sm:text-[28px]" data-id="element-81" data-mp="jskwhmobnh0r">
        One retained client pays for this system ten times over.
      </p>
      <p className="mt-4 text-center font-sans text-[16px] font-semibold text-sage" data-id="element-82" data-mp="298wwdtjrsuar">
        Your next "I have a bad back" can go completely differently.
      </p>
    </Section>;
}